import React from 'react'
import PropTypes from 'prop-types'

const ContentSlotMain = ({ placeholders: { contents = []} = {}}) =>
  <div data-max-width>
    { contents }
  </div>

ContentSlotMain.propTypes = {
  placeholders: PropTypes.shape({
    contents: PropTypes.array
  })
}

ContentSlotMain.type = ['ContentSlotMain', 'BOTAppointmentContentSlotMain']
ContentSlotMain.placeholders = ['contents']

export default ContentSlotMain
